import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class IdpGenericSamlIcon extends BaseIcon {
  getChildren = () => [
    <path fill="none" opacity=".7" d="M0 0h72v50H0z"/>,
    <g transform="translate(9.393 2.654)">
      <rect width="53" height="33" rx="2" transform="translate(.608 6.305)" fill="none" stroke="#2e3f58" strokeMiterlimit="10" strokeWidth="1.5"/>
      <path fill="none" stroke="#2e3f58" strokeMiterlimit="10" strokeWidth="1.5" d="M24.608 6.305v33"/>
      <path fill="none" stroke="#2e3f58" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M28.826 18.511h18.031"/>
      <path fill="none" stroke="#2e3f58" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M28.826 25.38h12.021"/>
      <path d="M6.501 30.652c-.481.24-1.185.5-1.717.738h15.455a12.021 12.021 0 0 0-1.717-.738c-2.8-.979-3.744-1.958-3.744-3.915 0-1.236.944-.738 1.185-2.954.24-.979.944 0 1.185-2.2a1.1 1.1 0 0 0-.481-1 13.446 13.446 0 0 0 .24-2.2c.481-.979-.481-4.173-4.276-4.173a4.362 4.362 0 0 0-4.757 4.173 10.51 10.51 0 0 0 .24 2.2 1.546 1.546 0 0 0-.24 1c.24 2.2.944 1.219 1.185 2.2.481 2.215 1.185 1.717 1.185 2.954.001 1.957-.944 2.936-3.743 3.915Z" fill="#2e3f58"/>
    </g>
  ]
  getViewBox = () => '0 0 72 50'
}
